import React from "react";
import "../VisionVoteAdvantage.css";

import {
  FaUsers,
  FaShieldAlt,
  FaClock,
  FaRocket,
  FaCode,
  FaHandshake,
  FaLightbulb,
  FaHeadset,
} from "react-icons/fa";

const advantages = [
  {
    icon: <FaUsers />,
    title: "Experienced Professionals",
    description:
      "A passionate team of developers, designers, and consultants delivering innovative digital solutions."
  },
  {
    icon: <FaShieldAlt />,
    title: "Secure by Design",
    description:
      "Every solution is built with security, scalability, and reliability at its core."
  },
  {
    icon: <FaClock />,
    title: "On-Time Delivery",
    description:
      "We follow agile methodologies and transparent workflows to ensure timely project completion."
  },
  {
    icon: <FaRocket />,
    title: "Innovation Driven",
    description:
      "We leverage modern technologies including AI, cloud, and automation to build future-ready products."
  },
  {
    icon: <FaCode />,
    title: "Custom Development",
    description:
      "Every application is tailored specifically to your business objectives and operational needs."
  },
  {
    icon: <FaHandshake />,
    title: "Trusted Partnership",
    description:
      "We believe in long-term collaboration, transparency, and continuous business support."
  },
  {
    icon: <FaLightbulb />,
    title: "Business Consulting",
    description:
      "Beyond development, we provide strategic IT consulting to help organizations grow digitally."
  },
  {
    icon: <FaHeadset />,
    title: "Lifetime Support",
    description:
      "From deployment to maintenance, we ensure your software continues performing at its best."
  },
];

const VisionVoteAdvantage = () => {
  return (
    <section className="advantage">

      <div className="advantage-container">

        <span className="section-tag">
          THE VISIONVOTE ADVANTAGE
        </span>

        <h2>
          Why Businesses Choose
          <span> VisionVote Technologies</span>
        </h2>

        <p className="advantage-intro">
          At VisionVote Technologies, we combine innovation, engineering excellence,
          and strategic consulting to deliver solutions that create measurable
          business value. Our commitment to quality, transparency, and long-term
          partnerships makes us a trusted technology partner for organizations
          embracing digital transformation.
        </p>

        <div className="advantage-grid">

          {advantages.map((item, index) => (
            <div className="advantage-card" key={index}>

              <div className="advantage-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default VisionVoteAdvantage;